import { render, staticRenderFns } from "./leaveExamine.vue?vue&type=template&id=2f67bf9b&scoped=true&"
import script from "./leaveExamine.vue?vue&type=script&lang=js&"
export * from "./leaveExamine.vue?vue&type=script&lang=js&"
import style0 from "./leaveExamine.vue?vue&type=style&index=0&id=2f67bf9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67bf9b",
  null
  
)

export default component.exports